export default __webpack_public_path__ + "static/media/A_Male.5ef4a499.svg";